<template>
  <div class="hamburger-container" @click="toggleClick">
    <i :class="isActive ? 'el-icon-s-fold' : 'el-icon-s-unfold'" style="font-size: 20px;"></i>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      console.log('Hamburger clicked, current isActive:', this.isActive)
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger-container {
  padding: 0 15px;
  cursor: pointer;
  transition: background 0.3s;
  height: 100%;
  display: flex;
  align-items: center;
}

.hamburger-container:hover {
  background: rgba(0, 0, 0, 0.025);
}
</style> 